import { AdminDashboardStats } from "../../../types/adminDashboard";
import { InferActionsTypes } from "../index";

// Action Types
export const adminDashboardActionTypes = {
  GET_ADMIN_DASHBOARD_STATS: "adminDashboard/GET_ADMIN_DASHBOARD_STATS",
  GET_ADMIN_DASHBOARD_STATS_SUCCESS: "adminDashboard/GET_ADMIN_DASHBOARD_STATS_SUCCESS",
  GET_ADMIN_DASHBOARD_STATS_ERROR: "adminDashboard/GET_ADMIN_DASHBOARD_STATS_ERROR",
  REFRESH_ADMIN_DASHBOARD_STATS: "adminDashboard/REFRESH_ADMIN_DASHBOARD_STATS",
  REFRESH_ADMIN_DASHBOARD_STATS_SUCCESS: "adminDashboard/REFRESH_ADMIN_DASHBOARD_STATS_SUCCESS",
  REFRESH_ADMIN_DASHBOARD_STATS_ERROR: "adminDashboard/REFRESH_ADMIN_DASHBOARD_STATS_ERROR",
};

// State Interface
interface AdminDashboardState {
  stats: AdminDashboardStats | null;
  loading: boolean;
  refreshing: boolean;
  error: string | null;
}

const initialState: AdminDashboardState = {
  stats: null,
  loading: false,
  refreshing: false,
  error: null,
};

export const adminDashboardReducer = (
  state = initialState,
  action: any
): AdminDashboardState => {
  switch (action.type) {
    case adminDashboardActionTypes.GET_ADMIN_DASHBOARD_STATS:
      return { ...state, loading: true, error: null };
    case adminDashboardActionTypes.GET_ADMIN_DASHBOARD_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };
    case adminDashboardActionTypes.GET_ADMIN_DASHBOARD_STATS_ERROR:
      return { ...state, loading: false, error: action.payload };
    case adminDashboardActionTypes.REFRESH_ADMIN_DASHBOARD_STATS:
      return { ...state, refreshing: true, error: null };
    case adminDashboardActionTypes.REFRESH_ADMIN_DASHBOARD_STATS_SUCCESS:
      return { ...state, refreshing: false, stats: action.payload };
    case adminDashboardActionTypes.REFRESH_ADMIN_DASHBOARD_STATS_ERROR:
      return { ...state, refreshing: false, error: action.payload };
    default:
      return state;
  }
};

// Saga-dispatched actions (called from sagas)
export const adminDashboardActions = {
  getStatsSuccess: (data: AdminDashboardStats) => ({
    type: adminDashboardActionTypes.GET_ADMIN_DASHBOARD_STATS_SUCCESS,
    payload: data,
  }),
  getStatsError: (error: string) => ({
    type: adminDashboardActionTypes.GET_ADMIN_DASHBOARD_STATS_ERROR,
    payload: error,
  }),
  refreshStatsSuccess: (data: AdminDashboardStats) => ({
    type: adminDashboardActionTypes.REFRESH_ADMIN_DASHBOARD_STATS_SUCCESS,
    payload: data,
  }),
  refreshStatsError: (error: string) => ({
    type: adminDashboardActionTypes.REFRESH_ADMIN_DASHBOARD_STATS_ERROR,
    payload: error,
  }),
};

// Component-dispatched actions (called from components)
export const adminDashboardTriggerActions = {
  getStats: () => ({
    type: adminDashboardActionTypes.GET_ADMIN_DASHBOARD_STATS,
  }),
  refreshStats: () => ({
    type: adminDashboardActionTypes.REFRESH_ADMIN_DASHBOARD_STATS,
  }),
};

export type AdminDashboardActions = InferActionsTypes<typeof adminDashboardActions>;
